/**
 * Readers for the Cognito ID-token payload stored under the "user" key by
 * authSlice on sign-in. Kept separate from utils/auth.ts, which owns the
 * unrelated THERAPIST_DIRECT_* key scheme.
 */

interface StoredIdTokenPayload {
  email?: string;
  sub?: string;
  given_name?: string;
  family_name?: string;
  "custom:id_practice"?: string;
  "custom:user_role"?: string;
}

function getStoredUser(): StoredIdTokenPayload | null {
  try {
    const raw = localStorage.getItem("user");
    return raw ? (JSON.parse(raw) as StoredIdTokenPayload) : null;
  } catch (error) {
    console.error("Failed to parse stored user:", error);
    return null;
  }
}

/** The signed-in account's email — the address the Stripe customer is billed under. */
export function getAccountEmail(): string | undefined {
  return getStoredUser()?.email || undefined;
}

/** The signed-in account's Cognito sub. */
export function getAccountId(): string | undefined {
  return getStoredUser()?.sub || undefined;
}
